module.exports = __webpack_public_path__ + "static/media/Hunter G.c3da5819.png";